import React, { Component } from "react"

import { connect } from "react-redux"

import { OrangeButton } from "../../../common"
import { FixedHeader } from "../../../reduxified"
import {
  logScreenEnterance,
  LogoutUser,
  fetchAllLockersStatuses,
  getTasksByStation,
  saveFailedRequest,
} from "../../../../actions"

import "./style.css"
import ErrorInfoModal from "../../../Modals/ErrorInfoModal"

class DriverMenuScreen extends Component {
  constructor(props) {
    super(props)

    this.state = {
      showError: false,
      isMustCompleteTasks: false,
      isMustCollect: false,
    }
  }

  componentDidMount() {
    const {
      authenticated,
      role,
      roleOriginal,
      stationId,
      isNeedAccessibility,
    } = this.props

    if (!authenticated) {
      this.props.LogoutUser()
      this.props.history.push("")
    }

    this.props.getTasksByStation(stationId)
    this.props.fetchAllLockersStatuses(stationId, isNeedAccessibility)
    if (authenticated && role === "Customer" && roleOriginal === "Customer") {
      this.props.LogoutUser()
      this.props.history.push("")
      this.setState({ showError: true })
    }

    this.props.logScreenEnterance("DRIVER_MENU_SCREEN")
  }

  componentDidUpdate(prevProps) {
    const {
      authenticated,
      isDeliveryRole,
      isAnyOrderToReturn,
      isCollectOrdersScreenVisited,
      isLoadCleanOrdersScreenVisited,
      stationTasksList,
      isAnyOrderToCollect,
      isMustCollectFirstRole,
      isMustCompleteTasksFirstRole,
      isMustShowTasksFirstRoles,
      getStationTasksSuccess,
      isStationTasksScreenVisited,
      lockersStatusesSuccess,
      history,
    } = this.props

    if (!authenticated) {
      this.props.LogoutUser()
      this.props.history.push("")
    }
    if (
      isMustCompleteTasksFirstRole &&
      prevProps.getStationTasksSuccess !== getStationTasksSuccess &&
      getStationTasksSuccess &&
      stationTasksList?.length > 0
    ) {
      this.setState({ isMustCompleteTasks: true })
    }
    if (
      isAnyOrderToCollect &&
      isMustCollectFirstRole &&
      !this.state.isMustCollect
    ) {
      this.setState({ isMustCollect: true })
    }
    if (
      lockersStatusesSuccess &&
      !isLoadCleanOrdersScreenVisited &&
      !isCollectOrdersScreenVisited &&
      !isStationTasksScreenVisited
    ) {
      const hasTasks = stationTasksList?.length > 0
      const noTasks = stationTasksList?.length === 0

      if (hasTasks && isMustShowTasksFirstRoles) {
        history.push("StationTasksScreen")
      } else if (isAnyOrderToCollect && (noTasks || isDeliveryRole)) {
        history.push("CollectOrdersScreen")
      } else if (noTasks && isDeliveryRole && isAnyOrderToReturn) {
        history.push("LoadCleanOrdersScreen")
      } else if (noTasks && !this.state.isMustCollect) {
        history.push("LoadCleanOrdersScreen")
      }
    }
  }

  onDriverLoadingACellClick() {
    this.props.history.push("LoadCleanOrdersScreen")
  }

  onDriverCollectFromACellClick() {
    this.props.history.push("CollectOrdersScreen")
  }

  onDriverTasksCellClick() {
    this.props.history.push("StationTasksScreen")
  }

  onDriverDeliberatelyOpenCellsClick() {
    this.props.history.push("UnlockLockersScreen")
  }

  onGoBackClick() {
    this.props.history.goBack()
  }

  render() {
    const {
      dirRtl,
      user_menu_what_sub_title_text,
      driver_menu_ready_orders_loading,
      driver_menu_orders_collecting,
      driver_menu_lockers_cells_opening,
      driver_menu_tasks,
      back_btn_text,
      hello_title_text,
      firstName,
      isShowUnlockScreen,
      login_just_for_drivers,
      close_text,
      task_priority_text,
      collect_priority_text,
      stationTasksList,
      lockersStatusesSuccess,
    } = this.props
    const { showError } = this.state

    return (
      <div className="ls-wrapper">
        <FixedHeader buttonsFlag="driverMenuScreen" />
        <div className="dms-title" dir={dirRtl ? "rtl" : "ltr"}>
          {`${hello_title_text}, ${firstName}`}
        </div>
        <div className="dms-subtitle" dir={dirRtl ? "rtl" : "ltr"}>
          {user_menu_what_sub_title_text}
        </div>
        {this.state.isMustCompleteTasks && (
          <div className="task-priority-text">{task_priority_text}</div>
        )}
        {this.state.isMustCollect && !this.state.isMustCompleteTasks && (
          <div className="task-priority-text">{collect_priority_text}</div>
        )}
        {lockersStatusesSuccess ? (
          <div className="dms-wrapper">
            <OrangeButton
              isDisabled={
                this.state.isMustCompleteTasks || this.state.isMustCollect
              }
              extraClass="user-menu-btn"
              onClick={(e) => this.onDriverLoadingACellClick()}
            >
              {driver_menu_ready_orders_loading}
            </OrangeButton>
            <OrangeButton
              extraClass="user-menu-btn"
              onClick={(e) => this.onDriverCollectFromACellClick()}
            >
              {driver_menu_orders_collecting}
            </OrangeButton>
            <OrangeButton
              extraClass="user-menu-btn"
              onClick={(e) => this.onDriverDeliberatelyOpenCellsClick()}
              show={isShowUnlockScreen}
            >
              {driver_menu_lockers_cells_opening}
            </OrangeButton>
            {stationTasksList && stationTasksList?.length > 0 && (
              <OrangeButton
                extraClass="user-menu-btn"
                onClick={(e) => this.onDriverTasksCellClick()}
              >
                {driver_menu_tasks}
              </OrangeButton>
            )}
            <OrangeButton
              extraClass="user-menu-btn"
              onClick={(e) => this.onGoBackClick()}
            >
              {back_btn_text}
            </OrangeButton>
            {/* <OrangeButton
              extraClass="user-menu-btn"
              onClick={(e) =>
                this.props.saveFailedRequest({
                  url: "http://localhost:3000/api/Test",
                  method: "POST",
                  payload: {
                    lockerId: 1,
                    customerId: "test customerId",
                    stationId: "test stationId",
                  },
                  errorMessage: "test errorMessage",
                })
              }
            >
              TEST Failed Request
            </OrangeButton> */}
            <ErrorInfoModal
              dirRtl={dirRtl}
              show={showError}
              text={login_just_for_drivers}
              onModalCloseClick={() => this.setState({ showError: false })}
              closeTrnsl={close_text}
            />
          </div>
        ) : (
          <p className="dms-wrapper">Loading...</p>
        )}
      </div>
    )
  }
}

const mapStateToProps = ({
  translate,
  userLogin,
  lockersCells,
  visitingScreens,
  bgService,
  stationTasks,
}) => {
  const {
    authenticated,
    isDeliveryRole,
    isMustCollectFirstRole,
    isMustCompleteTasksFirstRole,
    isMustShowTasksFirstRoles,
    firstName,
    isShowUnlockScreen,
    role,
    isNeedAccessibility,
  } = userLogin
  const { isAnyOrderToReturn, isAnyOrderToCollect, lockersStatusesSuccess } =
    lockersCells
  const {
    isCollectOrdersScreenVisited,
    isLoadCleanOrdersScreenVisited,
    isStationTasksScreenVisited,
  } = visitingScreens
  const { stationId } = bgService
  const {
    dirRtl,
    user_menu_what_sub_title_text,
    driver_menu_ready_orders_loading,
    driver_menu_orders_collecting,
    driver_menu_lockers_cells_opening,
    driver_menu_tasks,
    back_btn_text,
    hello_title_text,
    login_just_for_drivers,
    close_text,
    task_priority_text,
    collect_priority_text,
  } = translate
  const { stationTasksList, getStationTasksSuccess } = stationTasks
  return {
    authenticated,
    role,
    isDeliveryRole,
    isShowUnlockScreen,
    isAnyOrderToReturn,
    isAnyOrderToCollect,
    isCollectOrdersScreenVisited,
    isLoadCleanOrdersScreenVisited,
    dirRtl,
    hello_title_text,
    user_menu_what_sub_title_text,
    driver_menu_ready_orders_loading,
    driver_menu_orders_collecting,
    driver_menu_lockers_cells_opening,
    driver_menu_tasks,
    back_btn_text,
    login_just_for_drivers,
    firstName,
    close_text,
    stationId,
    isNeedAccessibility,
    stationTasksList,
    getStationTasksSuccess,
    task_priority_text,
    collect_priority_text,
    isMustCollectFirstRole,
    isMustCompleteTasksFirstRole,
    isMustShowTasksFirstRoles,
    isStationTasksScreenVisited,
    lockersStatusesSuccess,
  }
}

export default connect(mapStateToProps, {
  logScreenEnterance,
  LogoutUser,
  fetchAllLockersStatuses,
  getTasksByStation,
  saveFailedRequest,
})(DriverMenuScreen)
